import './styles.scss';
import DATA from 'utils/data.json';
import moment from 'moment';
import Countdown from 'react-countdown';

const CountdownView = () => {
    
    const countDownRender = ({ days, hours, minutes, seconds, completed }) => {
        return (
            <div className="timer">
                <div className="time">
                    <p className="count-down__number">{days < 10 ? '0' + days : days}</p>
                    <p className="count-down__text">Days</p>
                </div>
                <div className="point">
                    <div />
                    <div />
                </div>

                <div className="time">
                    <p className="count-down__number">{hours < 10 ? '0' + hours : hours}</p>
                    <p className="count-down__text">Hours</p>
                </div>
                <div className="point">
                    <div />
                    <div />
                </div>

                <div className="time">
                    <p className="count-down__number">{minutes < 10 ? '0' + minutes : minutes}</p>
                    <p className="count-down__text">Minutes</p>
                </div>
            </div>
        )
    }

    return (
        <div className="count-down">
            <div>
                <p className="count-down__title">TIME REMAINING</p>
                <Countdown
                    date={moment(DATA['deadline'], 'DD/MM/YYYYTHH:mm:ss').toDate()}
                    renderer={countDownRender}
                />
            </div>
            <div className="line" />
            <div className="deadline">
                <p className="count-down__title">DEADLINE</p>
                <p className="count-down__number" style={{ marginTop: 8 }}>{moment(DATA['deadline'], 'DD/MM/YYYYTHH:mm:ss').format('DD')}</p>
                <p className="count-down__text">{moment(DATA['deadline'], 'DD/MM/YYYYTHH:mm:ss').format("MMMM")}</p>
            </div>
        </div>
    )
}

export default CountdownView